import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { BannerAppComponent } from '../../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../../components/footer-app/footer-app.component';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { InactivityService } from '../../../../services/inactivity/inactivity.service';
import { DetailsVehicleBannerComponent } from '../../../components/details-vehicle-banner/details-vehicle-banner.component';
import { NewVehicleComponent } from '../../components/new-vehicle/new-vehicle.component';

interface UploadedFile {
  id: string;
  file: File;
  name: string;
  size: number;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  errorMessage?: string;
}

@Component({
  selector: 'app-onerous-new-vehicle-page',
  templateUrl: './onerous-new-vehicle-page.component.html',
  styleUrl: './onerous-new-vehicle-page.component.scss',
  standalone: true,
  imports: [
    //Componentes
    //HeaderComponent,
    BannerAppComponent,
    DetailsVehicleBannerComponent,
    NewVehicleComponent,
    FooterAppComponent,
    FooterAppComponent,
  ],
})
export class OnerousNewVehiclePageComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private dataLayerService = inject(DataLayerService);
  inactivityService = inject(InactivityService);

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'onerosos');

    this.inactivityService.stopTimer();

    this.inactivityService.startDefaultTimerForScreen('Detalles-0km', 'Abandono 0 km', '40');

    this.dataLayerService.pushDataLayerOnerous('Pageview', 'moto_ecommerce_step_2.2_0km', '0km');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'onerosos');
    this.inactivityService.stopTimer();
  }
}
